import React, { FC, useEffect, useState } from "react";
import { Row, Col, Layout } from "antd";
import DispatchPanel from "./DispatchPanel/index";
import MapPanel from "./MapPanel/index";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
import DashboardModal from "../Dashboard/DashboardModal";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const RideDashboard: FC<{ socket: ISocket }> = ({ socket }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [callingPageId, setCallingPageId] = useState<string | undefined>(
    undefined
  );
  const [videoPlayerOpen, setVideoPlayerOpen] = useState<boolean>(false);
  const [isCallNotificationDisplayed, setCallNotificaitonDisplayed] =
    useState<boolean>(false);
  const [screens, setScreens] = useState<any>({
    form: true,
    map: true,
  });

  const params: any = {
    screens,
    setScreens,
  };

  const fixedColSize = 24;

  return (
    <Row className="main-layout">
      {screens.form && (
        <Col
          md={screens.map ? 12 : fixedColSize}
          xs={24}
          className={screens.active === "form" ? "active-screen" : ""}
          style={{ height: "65vh" }}
        >
          {screens.form && <DispatchPanel socket={socket} params={params} />}
        </Col>
      )}
      {screens.map && (
        <Col
          md={12}
          xs={24}
          className={screens.active === "map" ? "active-screen" : ""}
          style={{ height: "65vh" }}
        >
          <MapPanel socket={socket} params={params} />
        </Col>
      )}
      <Autocomplete
        apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
        style={{ display: "none" }}
        options={{
          types: ["(regions)"],
          componentRestrictions: { country: ["us", "ca", "uk"] },
        }}
      />

      <Col span={24} style={{ width: "calc(100vw - 60px)" }}>
        <div className="beam-modal analytics-summary-modal">
          <Layout
            className="main-layout exec-layout mt-3 pr-5 pl-4"
            style={{ padding: 0 }}
          >
            <DashboardModal socket={socket} />
          </Layout>
        </div>
      </Col>
    </Row>
  );
};

export default RideDashboard;
